"use client";

import type { SupabaseClient } from "@supabase/supabase-js";
import { isAuthTransitionPending } from "@/lib/auth/transition";

type AnonymousSignIn = SupabaseClient["auth"]["signInAnonymously"];
let inFlight: ReturnType<AnonymousSignIn> | undefined;

/** Share guest initialization across chat and funnel callers in this browser. */
export function startAnonymousSession(
  supabase: SupabaseClient,
  credentials?: Parameters<AnonymousSignIn>[0]
): ReturnType<AnonymousSignIn> {
  if (inFlight) return inFlight;
  if (isAuthTransitionPending()) {
    return Promise.reject(
      new Error("Die Anmeldung läuft bereits. Bitte versuchen Sie es anschließend erneut.")
    );
  }
  inFlight = supabase.auth.signInAnonymously(credentials).finally(() => {
    inFlight = undefined;
  });
  return inFlight;
}

/**
 * GoTrue saves a guest session when signup resolves, outside its session lock.
 * Let that write settle before an OTP changes the authenticated user. Failure
 * to create a guest must not prevent the user from logging in normally.
 */
export async function waitForAnonymousSession(): Promise<void> {
  try {
    await inFlight;
  } catch {
    /* The initiating caller reports guest signup errors. */
  }
}
